export enum ProductCode {
    EP = "EP",
    GP = "GP",
    TM_MP = "TM_MP",
    AP = "AP",
    CH_GP = "CH_GP",
    CH_EP = "CH_EP",
    CH_MP = "CH_MP",
    AIA_FG = "AIA_FG",
}

export const PRODUCT_CODE_LABELS: Record<ProductCode, string> = {
    [ProductCode.EP]: "Electronic Care",
    [ProductCode.GP]: "Gadget Care",
    [ProductCode.TM_MP]: "Merchandise Care",
    [ProductCode.AP]: "Allergy Care",
    [ProductCode.CH_GP]: "Gadget Care",
    [ProductCode.CH_EP]: "Electronic Care",
    [ProductCode.CH_MP]: "Merchandise Care",
    [ProductCode.AIA_FG]: "Fresh Guarantee",
};
